import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Without this, a throw in any component unmounts the whole tree and the
 * visitor sees a blank page.
 */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Wire this to an error reporter when one is configured.
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center bg-dark-base px-5 text-white">
        <div className="max-w-[460px] text-center">
          <img
            src="/assets/fork-logo.png"
            alt="FORK."
            className="mx-auto h-6 w-auto object-contain"
          />
          <h1 className="mt-8 text-[clamp(26px,4vw,38px)] font-extrabold leading-tight tracking-[-0.03em]">
            Something went wrong
          </h1>
          <p className="mt-4 text-[16px] leading-[1.6] text-dark-textSecondary">
            Sorry — this page hit an unexpected error. Reloading usually fixes
            it.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-7 inline-flex h-12 items-center rounded-xl bg-accent-bright px-6 text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors hover:bg-accent"
          >
            Reload the page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
